export enum UserConfirmationRequestState {
  Pending = 1,
  Approved,
  Declined,
}
